import { isGroupOfHotels } from '../utils';

export const selectColorTheme = (state) => state.config?.colorTheme || 'light';
export const selectLocale = (state) => state.config?.locale || 'en';
export const selectIsGroupOfHotels = (state) => !!state.hotelInfo ? isGroupOfHotels(state.hotelInfo) : null;
export const selectSelectedHotel = (state) => {
  if (state.selectedHotel) {
    return state.selectedHotel;
  }
  if (state.config?.hotelPreselected || !selectIsGroupOfHotels(state)) {
    return state.hotelData;
  }
  return null;
};
export const selectSDKAppVersion = (state) => {
  if (state.urlParams?.version?.match?.(/^v\d/)) {
    return state.urlParams?.version;
  }
  const hotelInfo = state.hotelInfo?.hotels?.find?.(({ id }) => id === state.hotelData?.id);
  if (hotelInfo?.app_version === 'v3' && hotelInfo?.enable_v3_new_ui_version) {
    return 'v3.5';
  }
  return hotelInfo?.app_version || 'v2';
};
